import { contains } from '../../utils/index.js';
import { YearPicker } from './YearPicker/index.js';
import { Header } from './Header/index.js';
import { Container, Column } from '../styled.js';
import { DatePicker } from './DatePicker/index.js';
import { useCalendar } from '../Context.js';
import { jsx, jsxs } from 'react/jsx-runtime';

function Calendar() {
  var _useCalendar = useCalendar(),
    onFocus = _useCalendar.onFocus,
    onBlur = _useCalendar.onBlur,
    onKeyDown = _useCalendar.onKeyDown,
    yearPickerVisible = _useCalendar.yearPickerVisible;
  var handleBlur = function handleBlur(event) {
    if (onBlur && !contains(event.currentTarget, event.relatedTarget)) {
      onBlur(event);
    }
  };
  return /*#__PURE__*/jsx(Container, {
    tabIndex: 0,
    onFocus: onFocus,
    onBlur: handleBlur,
    onKeyDown: onKeyDown,
    children: /*#__PURE__*/jsxs(Column, {
      children: [/*#__PURE__*/jsx(Header, {}), yearPickerVisible ? /*#__PURE__*/jsx(YearPicker, {}) : /*#__PURE__*/jsx(DatePicker, {})]
    })
  });
}

export { Calendar };
